<template>
  <section id="modal-info" v-if="isOpenModal" class="modal-overlay">
    <div class="modal-container" :class="classModal">
      <h2 class="modal-title">{{ titleModal }}</h2>
      <p class="modal-content">{{ contentModal }}</p>
    </div>
  </section>
  <section id="viewerDoc" v-else>
    <VHeader
      :title="title"
      :isPublic="isPublic"
      :canPrint="canPrint"
      :canDownload="canDownload"
      :ownerRevision="ownerRevision"
      :oldRevision="oldRevision"
      :url="url"
      :canPrintSampleWatermark="canPrintSampleWatermark"
      :canPrintWatermarkRevisionHistory="canPrintWatermarkRevisionHistory"
      :canPrintWatermark="canPrintWatermark"
      :canDownloadWatermark="canDownloadWatermark"
      :revisionData="revisionData"
    />
    <VDocument
      :isPublic="isPublic"
      :canPrint="canPrint"
      :canDownload="canDownload"
      :title="`${title}.pdf`"
      :url="url" />
  </section>  
</template>

<script>
import "vue-pdf-app-with-sign/dist/icons/main.css";
import VHeader from "./VHeader";
import VDocument from "./VDocument";

export default {
  name: "DDViewer",

  components: {
    VHeader,
    VDocument
  },

  props: {
    url: String,
    title: String,
    isPublic: Boolean,
    canPrint: Boolean,
    ownerRevision: Boolean,
    oldRevision: Boolean,
    canPrintWatermark: Boolean,
    canDownloadWatermark: Boolean,
    canPrintSampleWatermark: Boolean,
    canPrintWatermarkRevisionHistory: Boolean,
    canDownload: Boolean,
    isOpenModal: Boolean,
    titleModal: String,
    contentModal: String,
    classModal: String,
    baseUrlRedirect: String,
    isSearchTerm: String,
    revisionData: Object
  },

  data() {
    return {
      cScale: 1,
      currentPage: 1,
      searchController: null,
      linkService: null,
      pdfByte: null,
      config3: {
        toolbar: false
      }
    };
  },

};
</script>

<style scoped>
.viewerContent {
  width: 70%;
  top: 5px;
  left: 0;
  background: #42b983;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-container {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  width: 90%;
  max-width: 480px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  animation: fadeIn 0.3s ease;
  border-top: 6px solid transparent;
}

.modal-title {
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.modal-content {
  font-size: 1.2rem;
  color: #555;
  line-height: 1.6;
}

.md-info {
  border-top-color: #3498db;
  background: #f4f9ff;
}

.md-info .modal-title {
  color: #21618c;
}

.md-error {
  border-top-color: #e74c3c;
  background: #fff6f6;
}

.md-error .modal-title {
  color: #b32018;
}

.md-success {
  border-top-color: #42b983;
  background: #f9fffc;
}
.md-success .modal-title {
  color: #2a7f5f;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>